import React from 'react';
import { useLanguage } from './LanguageContext';
export const BeforeAfter = () => {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-gold-light py-16 md:py-20" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-10 md:mb-12 px-2" data-id="element-16">
          <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[4px] uppercase block mb-4" data-id="element-17">
            {t('ba.label')}
          </span>
          <h2 className="font-montserrat font-extrabold text-[26px] md:text-[42px] text-brand-navy mb-4 leading-[1.3] md:leading-tight" data-id="element-18">
            {t('ba.title')}
          </h2>
          <p className="font-inter text-[15px] md:text-[18px] text-[#4A5568] max-w-[600px] mx-auto" data-id="element-19">
            {t('ba.sub')}
          </p>
        </div>

        <div className="max-w-[800px] mx-auto" data-id="element-20">
          {/* Single Column Layout: Image -> Video -> Image */}
          <div className="flex flex-col gap-10 mb-12" data-id="element-21">
            {/* Card 1: Toilet Bowl */}
            <div className="flex flex-col items-center w-full mx-auto" data-id="element-22">
              <div className="w-full h-auto overflow-hidden rounded-[12px] bg-[#F8F6F2] flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/rPzaKN7zJcbMkNSXQcZhhN/Toilet_bowl.png" alt="Toilet Bowl Deep Clean Before and After" className="w-full h-auto object-contain rounded-[12px]" data-id="element-24" />
              </div>
              <div className="bg-brand-navy text-white font-inter font-medium text-[13px] px-4 py-1.5 rounded-full shadow-sm text-center w-full mt-3" data-id="element-25">
                ✓ Toilet Bowl Deep Clean · Miami, FL
              </div>
            </div>

            {/* Card 2: Shower Head */}
            <div className="flex flex-col items-center w-full mx-auto" data-id="element-26">
              <div className="w-full h-auto overflow-hidden rounded-[12px] bg-[#F8F6F2] flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-27">
                <img src="https://cdn.magicpatterns.com/uploads/amPmUJXMELKdPn32WRKdXu/Shower_head.jpg" alt="Shower Head Deep Clean Before and After" className="w-full h-auto object-contain rounded-[12px]" data-id="element-28" />
              </div>
              <div className="bg-brand-navy text-white font-inter font-medium text-[13px] px-4 py-1.5 rounded-full shadow-sm text-center w-full mt-3" data-id="element-29">
                ✓ Shower Head Deep Clean · Miami, FL
              </div>
            </div>
          </div>

          {/* Stats Bar — single row on mobile, equal columns */}
          <div className="bg-white py-5 px-3 md:p-7 md:px-10 grid grid-cols-3 md:flex md:flex-row md:justify-between items-center gap-2 md:gap-6 shadow-lg rounded-[20px]" style={{
          borderTop: '3px solid #C9A84C'
        }} data-id="element-30">
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-31">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-32">
                100%
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-33">
                {t('ba.stat1')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-34" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left border-x md:border-0 border-[#F0DCE6]" data-id="element-35">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-gold leading-none" data-id="element-36">
                24h
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-37">
                {t('ba.stat2')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-38" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-39">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-40">
                5★
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-41">
                {t('ba.stat3')}
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 md:mt-9 px-4 md:px-0" data-id="element-42">
          <button onClick={() => scrollTo('contact')} className="bg-brand-gold hover:bg-white text-brand-navy hover:text-brand-navy font-montserrat font-extrabold w-full sm:w-auto h-[48px] md:h-[56px] px-6 md:px-11 rounded-[28px] inline-flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 text-[14px] md:text-base" style={{
          boxShadow: '0 8px 25px rgba(201,168,76,0.40)'
        }} data-id="element-43">
            {t('ba.cta')}
          </button>
        </div>
      </div>
    </section>;
};